import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

// -------------------- A P I  C A L L S --------------------

export const InsertPrintingEntry = createAsyncThunk(
    'InsertPrintingEntry',
    async (postData) => {
        const response = await axios.post(`${baseUrl}?apicall=InsertPrintingEntry`, postData);
        return response.data;
    }
);

export const insertPrintInward = createAsyncThunk(
    'insertPrintInward',
    async (postData) => {
        //       console.log("postdata=>",postData);
        const response = await axios.post(`${baseUrl}?apicall=insertPrintInwardEntry`, postData);
        //console.log("API=>",response.data);
        return response.data;
    }
);

export const fetchPrintOutNo = createAsyncThunk(
    'fetchPrintOutNo',
    async () => {
        const response = await axios.get(`${baseUrl}?apicall=getPrintOutNo`);
        return response.data;
    }
);

export const fetchPrintInwardNo = createAsyncThunk(
    'fetchPrintInwardNo',
    async () => {
        const response = await axios.get(`${baseUrl}?apicall=getPrintingInwardNo`);
        return response.data;
    }
);

export const fetchPrintingOutwardInfo = createAsyncThunk(
    'fetchPrintingOutwardInfo',
    async () => {
        const response = await axios.get(`${baseUrl}?apicall=getPrintingOutwardInfo`);
        return response.data;
    }
);
export const fetchPrintingInwardInfo = createAsyncThunk(
    'fetchPrintingInwardInfo',
    async () => {
        const response = await axios.get(`${baseUrl}?apicall=getPrintingInwardInfo`);
        //console.log("response=>",response.data);
        return response.data;
    }
);
export const deletePrintingDetails = createAsyncThunk(
    "deletePrintingDetails",
    async (id) => {
        const response = await axios.delete(
            `${baseUrl}?apicall=getDeletePrintingDetails&id=${id}`
        );
        return response.data;
    }
);

export const deletePrintingInwardDetails = createAsyncThunk(
    "deletePrintingInwardDetails",
    async (id) => {
        const response = await axios.delete(
            `${baseUrl}?apicall=getDeletePrintingInwardDetails&id=${id}`
        );
        // console.log("Api=<",response.data);
        return response.data;
    }
);


export const fetchPrintingSingleOutwardInfo = createAsyncThunk(
    "fetchPrintingSingleOutwardInfo",
    async (id) => {
        const response = await axios.get(
            `${baseUrl}?apicall=getPrintingSingleOutwardInfo&id=${id}`
        );
        return response.data;
    }
);



// -------------------- S L I C E --------------------

const quotationSlice = createSlice({
    name: 'PrintingData',
    initialState: {
        isLoading: false,
        quotNo: null,
        printoutNo: null,
        printoutData: null,
        Qviewlist: null,
        deletePrinting: null,
        singlePrintoutData: null,
        printinNo: null,
        printinData: null,
        deletePrintingIw: null,
        isError: false
    },

    extraReducers: (builder) => {

        // -------------------- fetch print out no --------------------
        builder.addCase(fetchPrintOutNo.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPrintOutNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.printoutNo = action.payload;
        });
        builder.addCase(fetchPrintOutNo.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            console.log("Error:", action.error.message);
        });

        // -------------------- fetch print inward no --------------------
        builder.addCase(fetchPrintInwardNo.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPrintInwardNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.printinNo = action.payload;
        });
        builder.addCase(fetchPrintInwardNo.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            console.log("Error:", action.error.message);
        });

        // -------------------- fetch printing outward info --------------------
        builder.addCase(fetchPrintingOutwardInfo.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPrintingOutwardInfo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.printoutData = action.payload;
        });
        builder.addCase(fetchPrintingOutwardInfo.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            console.log("Error:", action.error.message);
        });

        // -------------------- delete printing entry --------------------
        builder.addCase(deletePrintingDetails.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(deletePrintingDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deletePrinting = action.payload;

            // remove deleted item from list
            if (state.printoutData && Array.isArray(state.printoutData)) {
                state.printoutData = state.printoutData.filter(
                    (item) => item.ID !== action.meta.arg
                );
            }
        });
        builder.addCase(deletePrintingDetails.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            console.log("Delete Error:", action.error.message);
        });

        // -------------------- delete printing inward entry --------------------
        builder.addCase(deletePrintingInwardDetails.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(deletePrintingInwardDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deletePrintingIw = action.payload;

            // remove deleted item from list
            if (state.printinData && Array.isArray(state.printinData)) {
                state.printinData = state.printinData.filter(
                    (item) => item.ID !== action.meta.arg
                );
            }
        });
        builder.addCase(deletePrintingInwardDetails.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            console.log("Delete Error:", action.error.message);
        });

        // -------------------- fetch single printing outward info --------------------
        builder.addCase(fetchPrintingSingleOutwardInfo.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPrintingSingleOutwardInfo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singlePrintoutData = action.payload;
        });
        builder.addCase(fetchPrintingSingleOutwardInfo.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            console.log("Single Fetch Error:", action.error.message);
        });

        // -------------------- fetch printing inward info --------------------
        builder.addCase(fetchPrintingInwardInfo.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPrintingInwardInfo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.printinData = action.payload;
        });
        builder.addCase(fetchPrintingInwardInfo.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            console.log("Error:", action.error.message);
        });


    }
});

export default quotationSlice.reducer;
